/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Substatus_Package_ProcessingInputs */

const tr_geliver_substatus_package_processing = /** @type {(inputs: Geliver_Substatus_Package_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İşlemde`)
};

const en_geliver_substatus_package_processing = /** @type {(inputs: Geliver_Substatus_Package_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing`)
};

const de_geliver_substatus_package_processing = /** @type {(inputs: Geliver_Substatus_Package_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Bearbeitung`)
};

const ru_geliver_substatus_package_processing = /** @type {(inputs: Geliver_Substatus_Package_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработка`)
};

/**
* | output |
* | --- |
* | "Processing" |
*
* @param {Geliver_Substatus_Package_ProcessingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_substatus_package_processing = /** @type {((inputs?: Geliver_Substatus_Package_ProcessingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Substatus_Package_ProcessingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_substatus_package_processing(inputs)
	if (locale === "de") return de_geliver_substatus_package_processing(inputs)
	if (locale === "ru") return ru_geliver_substatus_package_processing(inputs)
	return tr_geliver_substatus_package_processing(inputs)
});